const articles = {
  pageTitle: '精选文章',
  pageDescription: '阅读岛国精品为您精选的日本商品相关文章，涵盖美妆护肤技巧、食品文化、生活指南等丰富内容。',
  emptyArticles: '暂无文章，敬请期待',
  articleNotFound: '文章未找到',
  backToArticles: '返回文章列表',
};

export default articles;